import axios from 'axios';
import {
  CreateApiKeyParams,
  ApiKey,
  DeleteApiKeyParams,
  ListApiKeyParams,
  ListApiKeyResponse,
  GetApiKeySecretParams,
  GetApiKeySecretResponse,
  UpdateApiKeyParams,
} from '@/types/api-key';

// 创建 API Key
export const createApiKeyApi = (data: CreateApiKeyParams) => {
  return axios.post<{
    api_key: string;
    code: number;
    msg: string;
    data: ApiKey;
    trace_id: string;
  }>('/api/console/api-key/v1/create', data);
};

// 删除 API Key
export const deleteApiKeyApi = (data: DeleteApiKeyParams) => {
  return axios.post<void>('/api/console/api-key/v1/delete', data);
};

// 查询 API Key 列表
export const listApiKeyApi = (data: ListApiKeyParams) => {
  return axios.post<ListApiKeyResponse>('/api/console/api-key/v1/list', data);
};

// 获取 API Key 明文
export const getApiKeySecretApi = (data: GetApiKeySecretParams) => {
  return axios.post<GetApiKeySecretResponse>(
    '/api/console/api-key/v1/secret',
    data
  );
};

// 更新 API Key 基本信息
export const updateApiKeyApi = (data: UpdateApiKeyParams) => {
  return axios.post<void>('/api/console/api-key/v1/update', data);
};

export default {
  createApiKeyApi,
  deleteApiKeyApi,
  listApiKeyApi,
  getApiKeySecretApi,
  updateApiKeyApi,
};
